import { render, staticRenderFns } from "./TransactionsStatisticsFilters.vue?vue&type=template&id=4e45f896&"
import script from "./TransactionsStatisticsFilters.vue?vue&type=script&lang=js&"
export * from "./TransactionsStatisticsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports